import jwt from "../../http/requests/authSite/jwt/index.js";
//import router from '@/router'

export default {
	/*updateUsername ({
		commit
	}, payload) {
		console.log('updateUsername');
		payload.user.updateProfile({
			displayName: payload.displayName
		}).then(() => {

			// If username update is success
			let newUserData = Object.assign({}, payload.user.providerData[0]);
			newUserData.displayName = payload.displayName;
			commit('UPDATE_USER_INFO', newUserData, {
				root: true
			});

			// If reload is required to get fresh data after update
			// Reload current page
			/*if (payload.isReloadRequired) {
				router.push(router.currentRoute.query.to || '/')
			}* /
		}).catch((err) => {
			payload.notify({
				time: 8800,
				title: 'Error',
				text: err.message,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger'
			});
		});
	},*/
	// JWT
	loginJWT ({
		commit
	}, payload) {
		return new Promise((resolve, reject) => {
			jwt.login(payload.userDetails.email, payload.userDetails.password, payload.checkbox_remember_me, payload["g-recaptcha-response"])
				.then(response => {
					//console.log('LOGIN RESP', response);
					if (response &&
						response.data &&
						response.data.userData &&
						response.data.accessContaToken
					) {
						commit('UPDATE_USER_INFO', response.data.userData, {
							root: true
						});
						commit("SET_BEARER", response.data.accessContaToken);
						resolve(response);
					} else {
						commit('REMOVE_USER_INFO', null, {
							root: true
						});
						commit("REMOVE_BEARER");
						reject({
							message: "Wrong email or password."
						});
					}
				})
				.catch(error => {
					commit('REMOVE_USER_INFO', null, {
						root: true
					});
					commit("REMOVE_BEARER");
					reject(error);
				});
		});
	},
	refreshJWTToken ({
		commit,
		rootState
	}, payload) {
		return new Promise((resolve, reject) => {
			if (rootState.logoutAsked) {
				console.log('refreshJWTToken11');
				commit('REMOVE_USER_INFO', null, {
					root: true
				});
				commit("REMOVE_BEARER");
				reject({
					code: 401
				});
			} else {
				console.log('refreshJWTToken');
				jwt.refreshToken(payload.token)
					.then(response => {
						//console.log('refreshJWTToken RESP', response);
						if (response &&
							response.data &&
							response.data.userData &&
							response.data.accessContaToken &&
							!rootState.logoutAsked
						) {
							commit('UPDATE_USER_INFO', response.data.userData, {
								root: true
							});
							commit("SET_BEARER", response.data.accessContaToken);
							resolve(response);
						} else {
							console.log('refreshJWTToken');
							commit('REMOVE_USER_INFO', null, {
								root: true
							});
							commit("REMOVE_BEARER");
							reject({
								code: 401
							});
						}
					})
					.catch(error => {
						if (error &&
							error.response &&
							error.response.status == 401
						) {
							console.log('refreshJWTToken2');
							commit('REMOVE_USER_INFO', null, {
								root: true
							});
							commit("REMOVE_BEARER");
						}
						reject(error);
					});
			}
		});
	},
	logoutJWT ({
		commit,
		rootState
	}, payload) {
		return new Promise((resolve, reject) => {
			if (rootState.logoutAsked) {
				console.log('logoutJWT logoutAsked');
				commit('REMOVE_USER_INFO', null, {
					root: true
				});
				commit("REMOVE_BEARER");
				resolve(true);
			} else {
				console.log('logoutJWT process request');
				jwt.logout()
					.then(response => {
						if (response &&
							response.data &&
							response.data.loggedOut
						) {
							commit('SET_LOGOUT', null, {
								root: true
							});
							commit('REMOVE_USER_INFO', null, {
								root: true
							});
							commit("REMOVE_BEARER");
							resolve(response);
						} else if (response && response.data) {
							reject({
								message: response.data
							});
						} else {
							reject({
								message: 'Unable to logout.'
							});
						}
					})
					.catch(error => {
						if (error &&
							error.response &&
							(
								error.response.status == 428 ||
								error.response.status == 401
							)
						) {
							commit('SET_LOGOUT', null, {
								root: true
							});
							commit('REMOVE_USER_INFO', null, {
								root: true
							});
							commit("REMOVE_BEARER");
						}
						reject(error);
					});
			}
		});
	}

};
